<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-breadcrumbs
    class="breadcrumb-wrapper"
    :items="getItems"
  >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :disabled="item.disabled"
        :href="item.to"
      >
        <v-label dark class="breadcrumb-item"> {{ item.text }} </v-label>
      </v-breadcrumbs-item>
    </template>
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import { useRoute } from 'vue-router/composables';
import { breadcrumbRoutes, routesLabels, topicsLabels } from '@/constants/routes/routes';
import './styles/breadcrumb.scss';

const { t } = useI18n();
const rte = useRoute();
const path = ref(rte.fullPath);
/**
 * Splits the current path to be displayed in the breadcrumb
 * Routes with parameters (add?id=55) are simplified with the regex to remove everything after the ?
 */
const getItems = computed(() => path.value.split('/').filter(level => level)
  .map((level: string) => ({
    text: t(routesLabels[level.replace(/\?.*$/, '')]) || t(topicsLabels[level]),
    exact: true,
    disabled: !breadcrumbRoutes[level],
    to: breadcrumbRoutes[level]
  })));

watch(
  () => rte.fullPath,
  () => {
    path.value = rte.fullPath;
  },
  { deep: true }
);

</script>
